// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"UploadingsModal\"] [name=\"UploadingError\"] {\r\n    font-size: 14px;\r\n    flex: 0 0 95px;\r\n    padding-left: 0;\r\n  }\r\n", ""]);
// Exports
module.exports = exports;
